// extracted by mini-css-extract-plugin
export default {"container":"R7MEH","avatar":"lOBtm","settings":"tHWgc","container2":"H4NIP","dropdown":"mZMp0","dropButton":"CDJeS"};